<template>
	<div>
		<Navbar @toggleSideNav="toggleNav" />
		<SubNav v-if="$route.meta.hasSubNav"></SubNav>
		<SearchOverlay></SearchOverlay>
		<div class="app" :class="{'app-search-open':searchOpen}">
			<router-view></router-view>
		</div>

	</div>
</template>

<script>
import Navbar from "@/pages/GhostNavbar";
import SubNav from "@/components/navbar/SubNav.vue";
import SearchOverlay from "@/components/navbar/SearchOverlay";
import { mapGetters } from 'vuex';

export default {
  	name: "webapp",
	components: {
		Navbar,
		SubNav,
		SearchOverlay
	},
	methods: {
		toggleNav() {
			this.$refs.rightSidenav.toggleNav();
        }
	},

	computed: {
		...mapGetters(["searchOpen"])
	}


};
</script>
